import { render, staticRenderFns } from "./bfrc.vue?vue&type=template&id=6bf89cdf&scoped=true"
import script from "./bfrc.vue?vue&type=script&lang=js"
export * from "./bfrc.vue?vue&type=script&lang=js"
import style0 from "./bfrc.vue?vue&type=style&index=0&id=6bf89cdf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf89cdf",
  null
  
)

export default component.exports